import { render, staticRenderFns } from "./PromptSelector.vue?vue&type=template&id=32d4398f&scoped=true&"
import script from "./PromptSelector.vue?vue&type=script&lang=js&"
export * from "./PromptSelector.vue?vue&type=script&lang=js&"
import style0 from "./PromptSelector.vue?vue&type=style&index=0&id=32d4398f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d4398f",
  null
  
)

export default component.exports